module.exports = __webpack_public_path__ + "img/active-stage.2e068e33.png";